export default __webpack_public_path__ + "static/media/heirs-burglary.8c2da3bb.png";